import React, { useState } from 'react'
import { Skeleton } from 'antd'
import { EditOutlined } from '@ant-design/icons'

import { useCaseViewContext } from '../../context'
import { formatTenDigitPhoneNumber } from '../../utils/phoneFormatter'
import { StyledButton } from '../Button'

import { Item } from "../Item"
import CopyString from '../CopyString'

import {
    Container,
    Header,
    SubHeader
} from "../../Styles"

import { parseDate, calculateAge } from "../../utils/dateFormatter";
import EditPatientModal from './EditPatient'

function renderGender(gender) {
    switch (gender?.toUpperCase()) {
        case 'M':
            return 'Male'
        case 'F':
            return 'Female'
        case 'O':
            return 'Other'
        default:
            return 'N/A'
    }
}



export const Metadata = ({ patientData }) => {
    const { apiType } = useCaseViewContext()
    const [editPatientModalVisible, setEditPatientModalVisible] = useState(false)
    const { patientDetails, patientDetailsLoading } = patientData || {}
    const patient = patientDetails

    return (
        <Container>
            <Skeleton loading={patientDetailsLoading || !patient} active paragraph={{ rows: 5 }}>
                <Header>
                    {`${patient?.firstName} ${patient?.lastName}`} 
                    <StyledButton 
                        size="small" 
                        style={{ marginLeft: 'auto', alignSelf: 'flex-end'}}
                        Icon={EditOutlined} 
                        onClick={() => setEditPatientModalVisible(true)} 
                    />
                </Header>
                <SubHeader>{`${renderGender(patient?.gender)}, ${parseDate(patient?.dob)} (${calculateAge(patient?.dob)}yo)`}</SubHeader>
                
                <Item label="Patient ID" value={<CopyString text={patient?._id} />} />
                <Item label="state" value={<strong>{patient?.state?.name}</strong>} />
                <Item label="email" value={<span style={{ textTransform: 'none' }}>{patient?.email}</span>} />
                <Item label="phone" value={formatTenDigitPhoneNumber(patient?.phone)} />
            </Skeleton>
            { editPatientModalVisible && (
                <EditPatientModal
                    onClose={() => setEditPatientModalVisible(false)}
                />
            )}
        </Container>
    )
}
